// Curated specialty tags for clinician profiles — autocomplete suggestions only.
// Free text is allowed; these encourage consistent, searchable tagging so a
// client searching "psychologist" finds clinicians who tagged it, even when the
// word isn't in their headline credential.
export const COMMON_SPECIALTIES: string[] = [
  // Professions / credentials
  'Psychologist',
  'Psychotherapist',
  'Counsellor',
  'Clinical Counsellor',
  'Registered Social Worker',
  'Marriage & Family Therapist',
  // Focus areas
  'Anxiety',
  'Depression',
  'Trauma',
  'PTSD',
  'Grief & Loss',
  'Stress',
  'Burnout',
  'Couples Therapy',
  'Family Therapy',
  'Children & Youth',
  'Adolescents',
  'Relationships',
  'Self-Esteem',
  'Life Transitions',
  'Addiction',
  'Eating Disorders',
  'OCD',
  'ADHD',
  'Autism',
  'LGBTQ+',
  // Modalities
  'CBT',
  'DBT',
  'EMDR',
  'ACT',
  'Mindfulness',
];
